import axios from "../../api/axiosInstance";
import { storeAccessor } from "../../api/storeAccessor";

export const STATUS = {
  SUCCESS: 1,
  ERROR: -1,
};

// UUID validation regex (strict format)
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;


export const isValidUUID = (uuid) => {
  return uuid && typeof uuid === 'string' && UUID_REGEX.test(uuid);
};

export const extractProjectIdFromURL = (pathname) => {
  try {
    const match = pathname.match(/\/projects\/([a-f0-9-]+)/i);
    if (match && match[1] && isValidUUID(match[1])) {
      return match[1];
    }
  } catch (error) {
    console.error('Error extracting project ID from URL:', error);
  }
  return null;
};

export const getProjectIdFromStore = () => {
  try {
    const state = storeAccessor.getState();
    const projectId = state?.projects?.selectedProject?.id;
    if (projectId && isValidUUID(projectId)) {
      return projectId;
    }
  } catch (error) {
    console.error('Error accessing project ID from store:', error);
  }
  return null;
};

export const getProjectId = () => {
  let projectId = extractProjectIdFromURL(window.location.pathname);
  if (!projectId) {
    projectId = getProjectIdFromStore();
  }
  return projectId;
};

export const extractErrorInfo = (error) => {
  const errorData = error?.response?.data || error;

  // Preserve all error fields from backend (message, code, line, column, context)
  const code = errorData?.code;
  return {
    status: STATUS.ERROR,
    message: errorData?.message || errorData?.error || error?.message || 'An error occurred',
    error: errorData?.message || errorData?.error || error?.message || 'An error occurred',
    code,
    line: errorData?.line,
    column: errorData?.column,
    context: errorData?.context,
    errors: errorData?.errors,
    statusCode: error?.response?.status,
  };
};